export default __webpack_public_path__ + "static/media/cst_500_women_jacket.614e2b94.jpg";